import IAsyncArgs from "../../../shared/contracts/IAsyncArgs";
import ITaskImport from "../../../shared/contracts/ITaskImport";
import useApi from "../../../shared/services/useApi.hook";

function useRMSCoreApi() {
  const TASK_IMPORT: string = "TaskImport";
  const RMS_CORE_URL: string = `${process.env.REACT_APP_RMS_CORE_URL}`;
  const TASK_ID: number = 0;
  const RMSCORE_TENANT_ID: number = 2;

  const { GET } = useApi();

  //GET CALLS SECTION
  const getTaskImportList = ({
    doIf,
    doBefore = () => {},
    doAfter = () => {},
    onFulfilled,
    onException = (exception: any) => {
      console.warn("exception", exception);
    },
  }: IAsyncArgs<ITaskImport[]>): void => {
    if (doIf()) {
      GET<ITaskImport[]>(
        `${RMS_CORE_URL}/${TASK_IMPORT}/${TASK_IMPORT}/${RMSCORE_TENANT_ID}/${TASK_ID}`,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  };

  // ---
  return {
    getTaskImportList,
  };
}
export default useRMSCoreApi;
